import { Box, Typography, Button, Container, Paper } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../../language";

export default function PaymentErrorConcurrent() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleRetry = () => {
    navigate("/OnboardingPay"); // 👈 go back to subscription plans
  };

  const handleSupport = () => {
    window.location.href = "mailto:support@yourdomain.com";
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          borderRadius: 4,
          textAlign: "center",
          backgroundColor: "#fff",
        }}
      >
        <Box sx={{ mb: 3 }}>
          <ErrorOutlineIcon color="error" sx={{ fontSize: 70 }} />
        </Box>

        <Typography variant="h5" fontWeight={600} gutterBottom>
          {t("onb_pe_title")}
        </Typography>

        <Typography variant="body1" sx={{ color: "text.secondary", mb: 4 }}>
          {t("onb_pe_body")}
        </Typography>

        <Box sx={{ display: "flex", gap: 2, justifyContent: "center" }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleRetry}
            sx={{ borderRadius: 2, px: 3 }}
          >
            {t("onb_pe_try_again")}
          </Button>

          <Button
            variant="outlined"
            color="secondary"
            size="large"
            onClick={handleSupport}
            sx={{ borderRadius: 2, px: 3 }}
          >
            {t("onb_pe_contact_support")}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
}
